import { render } from "./OpportunitiesList.vue?vue&type=template&id=1c2f0970"
import script from "./OpportunitiesList.vue?vue&type=script&lang=js"
export * from "./OpportunitiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__